import * as React from 'react';
import { Avatar } from 'ui/avatar/Avatar';
import { useUserData } from 'components/user/hooks/use-user-data';
import { FC } from 'react';
import { UserPanelBalance } from '../user-panel/UserPanelBalance';

const ProfileInfo: FC = () => {
  const userData = useUserData();

  return (
    <div className="dropdown-flat-header">
      <div className="dropdown-flat-header__avatar avatar">
        <Avatar image={userData.avatar.image} />
      </div>
      <div className="dropdown-flat-header__data">
        <div className="text text_lg text-truncate">
          {userData.fullName}
        </div>
        <div className="text text-truncate color-858585">
          {userData.email}
        </div>
      </div>
      <UserPanelBalance />
    </div>
  );
};

export { ProfileInfo };
